<template>
  <div class="card mb-25 border-0 rounded-0 welcome-box">
    <div class="card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6">
          <div class="title position-relative">
            <h3 class="fw-semibold mb-8">
              {{ $t('feature.home.welcome_message', {name: user?.info.firstname ?? user?.info.lastname ?? !stateStoreInstance.user?.info.role?.is_custom_role ? stateStoreInstance.user?.info.role.name : ''}) }}
            </h3>
            <span class="d-block text-black-emphasis fs-md-15 fs-lg-16">
              {{ $t('feature.home.welcome_subtitle') }}
            </span>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 text-center mt-15 mt-md-0">
          <img
            src="../../../assets/images/welcome/welcome2.png"
            alt="welcome-image"
          />
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "UserSummary",
  computed: {
    user(){ return stateStore.user },
    stateStoreInstance() { return stateStore }
  }
});
</script>